module.exports = __webpack_public_path__ + "img/2011-09_bloomberg.3fa3c6ce.jpg";